/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through integration tests (E2E) */
import "./style/cross.scss";
import $ from "jquery";
import { crossRmlAttachmentDetails, crossRmlInsertDialog, crossRclAssignGutenberg, crossRpmUpload, crossRcbGdprCompliant, crossRpmMove, crossRclAddCategory, crossRclAddWcCategory, CrossRclClassicEditorAssign, CrossRclPagination } from "./cross/index";
$(document).ready(() => {
  const CHECK_INTERVAL_MS = 1000;
  /**
   * Visible-driven
   * Check by an given ms-interval for given elements and
   */

  function checkByInterval() {
    let found = false;
    !found && (found = crossRmlAttachmentDetails());
    !found && (found = crossRcbGdprCompliant());
    !found && (found = crossRmlInsertDialog());
    !found && (found = crossRclAssignGutenberg());
    !found && (found = crossRpmUpload()); // Again, if nothing found

    !found && setTimeout(checkByInterval, CHECK_INTERVAL_MS);
  }

  setTimeout(checkByInterval, CHECK_INTERVAL_MS); // Event-driven

  crossRclAddCategory();
  crossRclAddWcCategory();
  crossRpmMove();
  CrossRclClassicEditorAssign.bind();
  CrossRclPagination.bind();
});